import * as S from "./styles";
import Car from "./assets/car.svg";
import Home from "./assets/home.svg";

import { IOccurrence } from "interfaces/Occurrence";
import { useState } from "react";

import { useEffect } from "react";

import { IReport } from "interfaces/Report";
import { socket } from "hooks/useSocket";
import ReactTooltip from "react-tooltip";
import { Button } from "monk_ui";
import { useAuth } from "contexts/authContext";

type CardProps = {
  occurrence: IOccurrence;
  reportClick: () => void;
};

export function OccurrenceCard({ occurrence, reportClick }: CardProps) {
  const { tenant } = useAuth();

  const [localOccurrence, setLocalOccurrence] = useState<IOccurrence>(
    {} as IOccurrence
  );

  const [occurrenceChanges, setOccurrenceChanges] = useState<
    IOccurrence | undefined
  >();

  function onOccurrenceChange(socketOccurrence: IOccurrence) {
    setOccurrenceChanges(socketOccurrence);
  }

  useEffect(() => {
    const color = localStorage.getItem("card-header");
    if (color) {
      document
        .getElementById("root")
        ?.style.setProperty("--card-header", color);
    }
    setLocalOccurrence(occurrence);

    socket.on(`occurrence-change-${occurrence.id}`, onOccurrenceChange);

    const report = occurrence.report?.length ? occurrence.report[0] : undefined;

    if (!report) {
      return
    }

    treatReportBadge(report);

    const countdownSocket = `countdown-${report.id}`;

    const countdownStopSocket = `countdown-stop-${report.id}`;

    socket.on(`report-update-${report.id}`, updateReportBadge);

    return () => {
      socket.off(countdownSocket);
      socket.off(countdownStopSocket);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (occurrenceChanges) {
      setLocalOccurrence((value) => {
        const _occurrence = {
          ...value,
          ...occurrenceChanges,
        };

        _occurrence.attendant = occurrence.attendant;

        return _occurrence;
      });
    }
  }, [occurrenceChanges]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const report = occurrence.report?.length ? occurrence.report[0] : undefined;
    if (!report) {
      return ;
    }

    treatReportBadge(report);

    const countdownSocket = `countdown-${report.id}`;

    const countdownStopSocket = `countdown-stop-${report.id}`;

    socket.on(`report-update-${report.id}`, updateReportBadge);

    return () => {
      socket.off(countdownSocket);
      socket.off(countdownStopSocket);
    };
  }, []);

  function updateReportBadge(report: IReport) {
    treatReportBadge(report);
  }

  function treatReportBadge(report: IReport) {
    if (report.estimatedArrival && !report.arrivalTime) {
      return socket.emit("policemanArrival", {
        report,
        tenantId: tenant?.id
      });
    }
  }

  function formatDate(occurrenceDate: Date) {
    function addZero(i: string | number) {
      if (Number(i) < 10) {
        i = "0" + i;
      }
      return i;
    }
    const date = new Date(occurrenceDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const dt = addZero(date.getDate());
    const hour = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());

    return (
      dt +
      "/" +
      month +
      "/" +
      year +
      " às " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }

  function isPolicemanWorktype() {
    return occurrence.workType === "Policial";
  }

  function formatPoliceman() {
    return localOccurrence.policemen && localOccurrence.policemen.length !== 0
      ? localOccurrence.policemen[0].policeman.user.name
      : "Sem prestador";
  }

  function formatAddress() {
    return (
      occurrence.occurrencesSuperficialAddresses.superficialAddress?.street +
      ", " +
      occurrence.occurrencesSuperficialAddresses.superficialAddress?.number +
      " - " +
      occurrence.occurrencesSuperficialAddresses.superficialAddress?.uf +
      " | CEP: " +
      occurrence.occurrencesSuperficialAddresses.superficialAddress?.postalCode
    );
  }

  return (
    <S.CardContainer data-cy="occurrence-card">
      <>
        <S.CardHeader>
          <S.CardHeaderInfo>
            {occurrence.patrimonialType === 1 ? (
              <img src={Home} alt="occurrence-img" />
            ) : (
              <img src={Car} alt="occurrence-img" />
            )}
            <S.Description>
              <h2>Ocorrência</h2>
              <p data-cy="type-occurrence">
                {occurrence.patrimonialType === 1
                  ? "Estabelecimento"
                  : "Veículo"}
              </p>
              <p>{`Protocolo: ${occurrence.protocol}`}</p>
            </S.Description>
          </S.CardHeaderInfo>
          <S.BadgeContainer
            vehicleFound={occurrence?.findCoords && occurrence.findCoords.length! > 0}
            finished={occurrence.status === 'concluido'}
          >
            {occurrence?.patrimonialType === 2 && (
              <p
                className="badge found-info"
              >
                {occurrence?.findCoords?.length! > 0 ? 'ENCONTRADO' : 'NÃO ENCONTRADO'}
              </p>
            )}

            <p className="badge finished-info">
              {occurrence.status === 'concluido' ? 'FINALIZADA' : 'EM ANDAMENTO'}
            </p>
          </S.BadgeContainer>
        </S.CardHeader>

        <S.CardBody>
          <S.CardRow>
            <S.CardColumn>
              <S.CardItem>
                <p className="title">Criado em: </p>
                <h4 title="data">{formatDate(occurrence.createdAt)}</h4>
              </S.CardItem>
              <S.CardItem>
                <p className="title">Atendente</p>
                <h4 title={occurrence.attendant.name} className="subtitle">
                  {occurrence.attendant.name}
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Subcliente</p>
                <h4
                  title={
                    occurrence.occurrencesSuperficialAddresses
                      .superficialAddress.superficialClient?.name
                  }
                  className="subtitle"
                >
                  {
                    occurrence.occurrencesSuperficialAddresses
                      .superficialAddress.superficialClient?.name
                  }
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Prestador</p>
                <h4 title={formatPoliceman()} className="subtitle">
                  {formatPoliceman()}
                </h4>
              </S.CardItem>
            </S.CardColumn>
            <S.CardColumn>
              <S.CardItem>
                <p className="title">Boletim</p>
                <h4
                  title={occurrence.numberBO || "Sem Boletim"}
                  className="subtitle boSubtitle"
                >
                  {occurrence.numberBO || "Sem Boletim"}
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Cliente</p>
                <h4
                  title={
                    occurrence.client.name
                  }
                  className="subtitle"
                >
                  {
                    occurrence.client.name
                  }
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Endereço</p>

                <h4 title={formatAddress()} className="subtitle">
                  {formatAddress()}
                </h4>
              </S.CardItem>

              <S.CardItem>
                <p className="title">Tipo do prestador</p>

                <h4 className="subtitle">
                  {isPolicemanWorktype() ? "Pronta-resposta" : "Assistente"}
                </h4>
              </S.CardItem>
            </S.CardColumn>
          </S.CardRow>
        </S.CardBody>

        <footer className="footer">
          <Button
            title="Ver mais detalhes"
            onClick={reportClick}
            size="large"
            background="#D6A606"
          />
        </footer>
      </>
    </S.CardContainer>
  );
}
